// ── Employee Performance: the drill-down's query ────────────────────────
//
// One employee's receipts for the view the widget is showing: the widget's own period and filters,
// plus the employee. Keyed under the page's main dashboard query, like the widget's figures, so the
// page's Refresh reloads an open drill-down along with everything else.

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuthStore } from '../../stores/authStore'
import type { EmployeePerformanceQueryContext } from '../../lib/employeePerformance'
import { buildEmployeeTransactionsUrl, fetchEmployeeTransactions, type EmployeeTransactionsData } from '../../lib/employeeTransactions'

export function useEmployeeTransactions(
    query: EmployeePerformanceQueryContext, employeeId: string,
): UseQueryResult<EmployeeTransactionsData, Error> {
    const token = useAuthStore(s => s.accessToken)
    const url = buildEmployeeTransactionsUrl(query.period, query.filters, employeeId)
    return useQuery<EmployeeTransactionsData, Error>({
        queryKey: [query.queryKeyPrefix, 'employee-performance', 'transactions', url],
        queryFn: () => fetchEmployeeTransactions(url, token),
        retry: false,
    })
}
